import styled from 'styled-components';

export const SkillsSection = styled.section`
  padding: 6rem 0;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 4rem 0;
  }
`;

export const SkillsWrapper = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
`;

export const SkillsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  margin-top: 3rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
`;

export const SkillsTextBlock = styled.div``;

export const SkillsCardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: repeat(2, 1fr);
    order: 2;
  }
`;

export const SkillsCard = styled.div`
  background: ${({ theme }) => theme.colors.bg_card};
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid ${({ theme }) => theme.colors.glass_border};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: 1.75rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  transition: ${({ theme }) => theme.transitions.default};
  cursor: default;

  &:hover {
    border-color: ${({ theme }) => theme.colors.glass_border_hover};
    background: ${({ theme }) => theme.colors.bg_card_hover};
    transform: translateY(-5px);
    box-shadow: ${({ theme }) => theme.shadows.card_hover};
  }

  h4 {
    color: ${({ theme }) => theme.colors.heading};
    font-size: 0.9rem;
    font-weight: ${({ theme }) => theme.fonts.weight.medium};
    text-align: center;
  }
`;
